import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceTag } from './PriceTag';
import { TrustStrip } from './TrustStrip';
import { MAIN_MOCKUP, OFFER_BADGE, OFFER_CLOSING, OFFER_CTA, OFFER_EYEBROW, OFFER_PRICE_LINE, OFFER_TITLE, OFFER_URGENCY, OFFER_URGENCY_SUB, offerItems, offerMicro } from '../data/halloweenKit';
export function OfferSection() {
  return <section id="offer" data-hide-sticky className="w-full border-y border-pumpkin/25 bg-black py-14 sm:py-20" aria-labelledby="offer-title" data-id="element-185" data-mp="icgenaahgr0w">
      <div className="mx-auto max-w-5xl px-5" data-id="element-186" data-mp="rdeoi97lrsre">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.24em] text-pumpkin" data-id="element-187" data-mp="repnlvq3scc6">{OFFER_EYEBROW}</p>
        <h2 id="offer-title" className="mt-3 text-center font-display text-[1.9rem] font-semibold leading-tight text-cream-50 sm:text-[2.7rem]" data-id="element-188" data-mp="wan7gc0ks0tp">
          {OFFER_TITLE[0]}
          <span className="block text-pumpkin-light" data-id="element-189" data-mp="2y6790aszbeyg">{OFFER_TITLE[1]}</span>
        </h2>

        <div className="mx-auto mt-6 max-w-xl text-center" data-id="element-190" data-mp="12plckvyk3hav">
          <p className="text-[15px] font-semibold leading-snug text-cream-50 sm:text-[16px]" data-id="element-191" data-mp="xvqs3qb4myaq">{OFFER_URGENCY}</p>
          <p className="mt-1.5 text-[14.5px] leading-relaxed text-body" data-id="element-192" data-mp="sy8j5zx40j2q">{OFFER_URGENCY_SUB}</p>
        </div>

        <div className="mt-9 grid items-center gap-8 md:grid-cols-2 md:gap-10" data-id="element-193" data-mp="oxyecql1zypg">
          <img src={MAIN_MOCKUP.src} alt={MAIN_MOCKUP.alt} width={MAIN_MOCKUP.width} height={MAIN_MOCKUP.height} loading="lazy" className="block h-auto w-full rounded-2xl object-contain" data-id="element-194" data-mp="1ll32uum3ref5" />

          <div className="rounded-3xl border border-pumpkin/40 bg-night-950 p-6 text-center sm:p-8" data-id="element-195" data-mp="17n4pnsjipo18">
            <span className="inline-block rounded-full bg-pumpkin px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-night-950" data-id="element-196" data-mp="172hhf1qqdbc">
              {OFFER_BADGE}
            </span>
            <PriceTag size="xl" className="mt-4" data-id="element-197" data-mp="3ttho2q550w5q" />
            <p className="mx-auto mt-3 max-w-xs text-[13.5px] font-medium leading-snug text-cream-200" data-id="element-198" data-mp="3tusp4i777pt5">{OFFER_PRICE_LINE}</p>

            <ul className="mt-6 space-y-3.5 border-t border-night-600 pt-6 text-left" data-id="element-199" data-mp="3ktbe3e8neebb">
              {offerItems.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-200" data-mp="3ou50222j5j1k">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-pumpkin/15" data-id="element-201" data-mp="3b3hzs5h4fl3d">
                    <CheckIcon className="h-3 w-3 text-pumpkin" strokeWidth={3} aria-hidden="true" data-id="element-202" data-mp="3fuhxve1z897g" />
                  </span>
                  <span data-id="element-203" data-mp="316n8a6j9mkyl">
                    <span className="block text-[15px] font-semibold leading-snug text-cream-50" data-id="element-204" data-mp="31393krn4pznz">{item.title}</span>
                    <span className="mt-0.5 block text-[13.5px] leading-snug text-body" data-id="element-205" data-mp="2s4nm6zte8qos">{item.detail}</span>
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 flex justify-center" data-id="element-206" data-mp="2x5tkdd5tp65p">
              <CtaButton size="md" label={OFFER_CTA} data-id="element-207" data-mp="2dizzb6vt3828" />
            </div>
            <TrustStrip items={offerMicro} className="mt-3" data-id="element-208" data-mp="28j3zlju562sh" />
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-lg italic leading-snug text-cream-100 sm:text-xl" data-id="element-209" data-mp="2midcoan1wgs8">
          {OFFER_CLOSING}
        </p>
      </div>
    </section>;
}